export interface LeadBannerPayload {
  name: string;
  phone: string;
}

export enum LeadBannerAvatarsSize {
  L = 'l',
  M = 'm',
}

export enum LeadBannerAppearance {
  Compact = 'compact',
  Default = 'default',
}
